module.exports = __webpack_public_path__ + "static/media/kalkulator.89376dc3.m4a";